var map = {
	"./fall2022/department_data.json": 61,
	"./fall2023/department_data.json": 294,
	"./fall2024/department_data.json": 271,
	"./fall2025/department_data.json": 432,
	"./fall2026/department_data.json": 1,
	"./spring2022/department_data.json": 53,
	"./spring2023/department_data.json": 913,
	"./spring2024/department_data.json": 615,
	"./spring2025/department_data.json": 800,
	"./spring2026/department_data.json": 17,
	"./spring2027/department_data.json": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;